import get from 'lodash/get';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/selling-terminals.api';
import sellingTerminalsWidgetTemplate from './selling-terminals-widget.html';

const TERMINAL_STATUS_ACTIVE_CODE = 2;

const mapStateToThis = ({ session }) => {
  const { retailer, baseUrl } = session;

  return {
    retailer,
    baseUrl,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope')
class SellingTerminalsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(
      () => Promise.all([api.fetchTerminalsDetails(retailerId), api.fetchTerminalsTemplates()]),
      this.transformData.bind(this)
    );
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getImageName(terminalType) {
    return `${this.baseUrl}api/game-image/view/terminal-${terminalType}.png`;
  }

  transformData(data) {
    const terminals = get(data, '[0]') || [];
    const terminalTemplates = get(data, '[1]') || [];

    const transformedData = terminals
      .filter((terminal) => terminal.statusCode === TERMINAL_STATUS_ACTIVE_CODE)
      .reduce((prev, curr, index) => {
        const ind = prev.findIndex((item) => item.terminalType === curr.terminalType);
        if (ind > -1) {
          prev[ind].index += 1;
          return prev;
        }

        const terminalTemplate = terminalTemplates.find((item) => item.terminalType === curr.terminalType);
        if (terminalTemplate) {
          curr.index ? (curr.index += 1) : (curr.index = 1);
          curr.terminalName = terminalTemplate.name;
          curr.imageName = this.getImageName({ terminalType: curr.terminalType });
          return prev.concat(curr);
        }
        return prev;
      }, []);

    return transformedData;
  }
}

export default class SellingTerminalsWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = sellingTerminalsWidgetTemplate;
    this.controller = SellingTerminalsWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/selling-terminals/selling-terminals-widget-component.js